import { useCallback, useEffect, useState } from "react";
import { adminApi, errText } from "./adminApi";

export default function AdminProducts() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [notice, setNotice] = useState("");
  const [drafts, setDrafts] = useState({});

  const load = useCallback(async () => {
    const { data } = await adminApi.get("/admin/products");
    setData(data);
    setDrafts(Object.fromEntries(data.products.map((p) => [p.product_key, (p.price_paise / 100).toString()])));
  }, []);
  useEffect(() => { load().catch(() => setError("Could not load products. Click Refresh.")); }, [load]);

  const save = async (p) => {
    setError("");
    setNotice("");
    const rupees = parseFloat(drafts[p.product_key]);
    if (isNaN(rupees) || rupees < 0) { setError(`Invalid price for ${p.name}.`); return; }
    try {
      await adminApi.put(`/admin/products/${p.product_key}`, { price_paise: Math.round(rupees * 100) });
      setNotice(`${p.name} price updated to ₹${rupees}.`);
      await load();
    } catch (err) { setError(errText(err)); }
  };

  const toggle = async (p) => {
    try { await adminApi.put(`/admin/products/${p.product_key}`, { active: !p.active }); await load(); }
    catch (err) { setError(errText(err)); }
  };

  return (
    <div data-testid="admin-products">
      <h4 style={{ marginBottom: 4 }}>Central Pricing Dashboard</h4>
      <span className="lead-sub">Every price a student sees comes from here — edit without touching code. The checkout amount always matches the displayed price.</span>
      {data && <p className={data.payments_live ? "tp-success-box" : "admin-error"} style={data.payments_live ? { background: "#123a2e", border: "1px solid #12b76a", color: "#4ade80" } : {}} data-testid="products-gateway">
        Payment gateway: {data.payments_live ? "Razorpay LIVE — keys configured" : "NOT CONFIGURED — add RAZORPAY_KEY_ID / RAZORPAY_KEY_SECRET / RAZORPAY_WEBHOOK_SECRET to activate checkout"}
      </p>}
      {error && <p className="admin-error" data-testid="products-error">{error}</p>}
      {notice && <p className="tp-success-box" style={{ background: "#123a2e", border: "1px solid #12b76a", color: "#4ade80" }}>{notice}</p>}
      {data && <div className="table-scroll"><table className="leads-table" data-testid="products-table">
        <thead><tr><th>PRODUCT</th><th>KIND</th><th>PERIOD</th><th>PRICE (₹)</th><th>STATUS</th><th>ACTIONS</th></tr></thead>
        <tbody>{data.products.map((p, i) => (
          <tr key={p.product_key} data-testid={`product-row-${i}`}>
            <td><div className="lead-name">{p.name}</div><div className="lead-sub">{p.description}</div></td>
            <td><span className="status-pill review">{p.kind}</span></td>
            <td>{p.period}</td>
            <td><input className="admin-input" style={{ width: 110 }} value={drafts[p.product_key] ?? ""} onChange={(e) => setDrafts((c) => ({ ...c, [p.product_key]: e.target.value }))} data-testid={`product-price-${i}`} /></td>
            <td><span className={p.active ? "status-pill approved" : "status-pill locked"}>{p.active ? "ON SALE" : "HIDDEN"}</span></td>
            <td><div className="admin-row" style={{ gap: 6 }}>
              <button className="admin-btn" onClick={() => save(p)} data-testid={`product-save-${i}`}>Save price</button>
              <button className="admin-btn" onClick={() => toggle(p)} data-testid={`product-toggle-${i}`}>{p.active ? "Hide" : "Show"}</button>
            </div></td>
          </tr>
        ))}</tbody>
      </table></div>}
    </div>
  );
}
